import { render } from "./TestimonialsSection.vue?vue&type=template&id=1086fe5c&scoped=true&ts=true"
import script from "./TestimonialsSection.vue?vue&type=script&lang=ts"
export * from "./TestimonialsSection.vue?vue&type=script&lang=ts"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=1086fe5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1086fe5c"]])

export default __exports__